<script setup lang="ts" generic="T extends AnyItem = AnyItem">
import type { AnyItem, CollectionRead } from '#layers/data-model/public';
import type { RenderDisplayTemplateProps } from './RenderDisplayTemplate.vue';
import { computed } from 'vue';
import { isEmptyDisplayTemplate, useCollection, useCollectionDisplayTemplate } from '#layers/data-model/public';

interface RenderCollectionDisplayTemplateProps extends RenderDisplayTemplateProps<T> {
	/** The read that loaded `item`, which decides the collection's display template. Rows a relation includes are `Many`. */
	read: CollectionRead;
}

// `truncationTooltip` is pulled out so its default survives forwarding: an absent boolean prop casts to `false`.
const { displayTemplate: displayTemplateProp, collectionId, read, truncationTooltip = true, ...forwarded } = defineProps<RenderCollectionDisplayTemplateProps>();

const { collection } = useCollection(() => collectionId);
const collectionDisplayTemplate = useCollectionDisplayTemplate(() => collection.value!, () => read); // we can safely unwrap here because we check for a collection before rendering the display template
const displayTemplate = computed(() => isEmptyDisplayTemplate(displayTemplateProp) ? collectionDisplayTemplate.value : displayTemplateProp);
</script>

<template>
	<DisplayTemplateConfigurationError v-if="!collection" :error="$t('display_template.missing_collection')" />
	<RenderDisplayTemplate v-else v-bind="forwarded" :collection-id :display-template :truncation-tooltip />
</template>
